import { render } from "./AppMain.vue?vue&type=template&id=06697351&scoped=true"
const script = {}

import "./AppMain.vue?vue&type=style&index=0&id=06697351&lang=scss&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/1fe6d5c2-02f8-4b7b-a7ed-3827401bba29/workspace/toilet-go-front_Ak2Q/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06697351"]])

export default __exports__